import { useData } from 'Data/ViewsData.js';
import View from './view.js';
import React from 'react';

export default function Logic() {
  let dataSignup = useData({ context: 'signup', path: 'signup.is_invite' });
  return <View disabled={dataSignup.value} />;
}
